import React from 'react';
import { IconProps } from '@/shared/types/icon';

const PhoneIcon: React.FC<IconProps> = ({
    size = 24,
    color = 'currentColor',
    width = 24,
    height = 24,
    ...props
}) => {
    return (
        <svg width={size || width} height={size || height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path d='M4.41333 7.19333C5.37333 9.08 6.92 10.62 8.80667 11.5867L10.2733 10.12C10.4533 9.94 10.72 9.88 10.9533 9.96C11.7 10.2067 12.5067 10.34 13.3333 10.34C13.7 10.34 14 10.64 14 11.0067V13.3333C14 13.7 13.7 14 13.3333 14C7.07333 14 2 8.92667 2 2.66667C2 2.3 2.3 2 2.66667 2H5C5.36667 2 5.66667 2.3 5.66667 2.66667C5.66667 3.5 5.8 4.3 6.04667 5.04667C6.12 5.28 6.06667 5.54 5.88 5.72667L4.41333 7.19333Z' fill='#5C5858' />
        </svg>
    );
};

export default PhoneIcon;
